import { CP_CONTRACTOR_TYPES } from "@/static/cpContractorTypes";
import { Expose } from "class-transformer";
import { IsArray, IsEnum, IsNumber, IsOptional, IsBoolean, IsString } from "class-validator";
import { CONTRACTOR_TYPE_TIN_ENUM } from "@/static/contractorTypeTINEnum";

export class EditContractor {
  @Expose()
  @IsString()
  name!: string;

  @Expose()
  @IsString()
  surname!: string;

  @Expose()
  @IsString()
  shortName!: string;

  @Expose()
  @IsOptional()
  @IsString()
  nationalBusinessRegistryNumber!: string | null;

  @Expose()
  @IsString()
  tin!: string;

  @Expose()
  @IsEnum(CONTRACTOR_TYPE_TIN_ENUM)
  countryTypeTIN!: CONTRACTOR_TYPE_TIN_ENUM;

  @Expose()
  @IsString()
  city!: string;

  @Expose()
  @IsString()
  country!: string;

  @Expose()
  @IsString()
  postalCode!: string;

  @Expose()
  @IsString()
  streetAndNumber!: string;

  @Expose()
  @IsOptional()
  @IsString()
  email!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  phoneNumber!: string | null;

  @Expose()
  @IsBoolean({ always: true })
  isIndividual!: boolean;

  @Expose()
  @IsBoolean()
  isVatGroupMember!: boolean;

  @Expose()
  @IsBoolean()
  isLocalGovernmentUnit!: boolean;

  @Expose()
  @IsArray()
  @IsEnum(CP_CONTRACTOR_TYPES, { each: true })
  contractorTypes!: Array<CP_CONTRACTOR_TYPES>;

  @Expose()
  @IsOptional()
  @IsNumber()
  recipientStatusId!: number | null;

  @Expose()
  @IsArray()
  contractorCategories!: Array<number>;

  constructor() {
    this.name = "";
    this.surname = "";
    this.shortName = "";
    this.nationalBusinessRegistryNumber = null;
    this.tin = "";
    this.countryTypeTIN = CONTRACTOR_TYPE_TIN_ENUM.PL;
    this.city = "";
    this.country = "";
    this.postalCode = "";
    this.streetAndNumber = "";
    this.email = null;
    this.recipientStatusId = null;
    this.phoneNumber = null;
    this.contractorTypes = new Array<CP_CONTRACTOR_TYPES>();
    this.contractorCategories = new Array<number>();
    this.isIndividual = false;
  }
}
